import React, { useEffect } from 'react'

import {
  StyledBottomSheet,
  StyledBottomSheetBackdrop,
} from './BottomSheet.styles'
import { useIOSKeyboardFix } from '@src/hooks/useIOSKeyboardFix'

import 'react-spring-bottom-sheet/dist/style.css'
import { BottomSheetController } from '../../hooks/useBottomSheetStack/useBottomSheetStack'

// A custom bottom sheet
// Its open/closed/minimised state is management by the useServiceComponent
// as that hook is aware of all the open BottomSheets, in order to prevent issue when multiple are "open"
export const BottomSheet: React.FC<{
  children: React.ReactNode
  onClose?: () => void
  onDismiss?: () => void
  bottomSheetController: BottomSheetController
  headerColor?: string
  height?: number
  maxWidth?: number
  backgroundColor?: string
  showBackdrop?: boolean
}> = ({
  children,
  // triggered when anything causes the bottom sheet to close
  onClose = () => {},
  // triggered when the bottom sheet is dismissed, eg by clicking outside
  onDismiss = () => {},
  bottomSheetController,
  headerColor,
  height = 0.87,
  maxWidth,
  backgroundColor,
  showBackdrop = true,
}) => {
  const { isIOS } = useIOSKeyboardFix()

  /**
   * On close call the onClose from the parent
   * This is in a useEffect so that it triggers when:
   * - the backdrop is clicked
   * - the bottom sheet is dismissed
   * - something external causes the bottom sheet to close
   **/
  useEffect(() => {
    if (!bottomSheetController.isOpen) {
      onClose()
    }
  }, [bottomSheetController.isOpen])

  const handleDismiss = () => {
    onDismiss()
    bottomSheetController.close()
  }

  return (
    <StyledBottomSheet
      onClick={e => {
        e.stopPropagation()
      }}
      open={bottomSheetController.isOpen}
      onDismiss={handleDismiss}
      snapPoints={({ maxHeight }) => [height * maxHeight]} // Static height to avoid keyboard on mobile covering up inputs
      sibling={
        // custom backdrop to prevent propagation of click events which were triggering other popover components' "on-click-outside" type events
        bottomSheetController.isOpen && (
          <StyledBottomSheetBackdrop
            role="presentation"
            showBackdrop={showBackdrop}
            // data-rsbs-backdrop="true"
            onClick={e => {
              e.stopPropagation()
              handleDismiss()
            }}
          />
        )
      }
      $headerColor={headerColor}
      $maxWidth={maxWidth}
      $backgroundColor={backgroundColor}
      $isMinimised={bottomSheetController.isMinimised}
      $isIOS={isIOS}
      blocking={false}
    >
      {children}
    </StyledBottomSheet>
  )
}
